import { getMethod, postMethod } from '@/services/apis/http-server';

export const SendMessage = async (body: any) => {
  try {
    const response = await postMethod(`public/ai-model/message`, body);
    return response;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const SendMessageChatbot = async (body: any) => {
  try {
    const response = await postMethod(`public/ai-model/message-chat`, body);
    return response;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};
